import type { Bi } from "@/components/landing/registry/types";

/**
 * Localized string from a `{ar,en}` content value, falling back through the
 * other locale, then to the provided i18n default so a never-edited field
 * still renders real copy.
 */
export function pickBi(value: Bi | undefined, locale: string, fallback = ""): string {
	const v = (value?.[locale as "ar" | "en"] ?? value?.en ?? value?.ar ?? "").trim();
	return v || fallback;
}
